import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { EthnicityValues, GraphDataEthnicity } from '../backend-response-models/calc-enums.helper';
import { AxialCalcResponse, CalcTreatmentResponse, SerCalcResponse } from '../backend-response-models/calc-interfaces.helper';
import { ChartModule } from 'primeng/chart';
import { ChipModule } from 'primeng/chip';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { COMMON_IMPORTS } from '../common-imports';
import { Dataset } from '../shared/shared-enums/enum-helper';
import { TranslatePipe } from '../languages/translate.pipe';
import { SerPercentileComponent } from '../ser-stats/ser-percentile/ser-percentile.component';
import { AxialPercentileComponent } from '../axial-stats/axial-percentile/axial-percentile.component';
import { ReportType } from '../shared/shared-enums/shared.enums';
import { ParentParagraphComponent, ParentParagraphType } from '../parent-paragraph/parent-paragraph.component';
import { ReferencesComponent } from '../shared/references/references.component';

@Component({
  selector: 'app-population-comparison',
  standalone: true,
  imports: [
    ...COMMON_IMPORTS,
    PanelModule,
    DropdownModule,
    ChartModule,
    ChipModule,
    DialogModule,
    TooltipModule,
    SerPercentileComponent,
    AxialPercentileComponent,
    ParentParagraphComponent,
    ReferencesComponent,
  ],
  templateUrl: './population-comparison.component.html',
  styleUrl: './population-comparison.component.css',
})
export class PopulationComparisonComponent implements OnChanges, OnInit {
  ReportType = ReportType;
  ParentParagraphType = ParentParagraphType;

  @Input({ required: true })
  serCalcResponse!: SerCalcResponse;

  @Input({ required: true })
  axialCalcResponse!: AxialCalcResponse;

  @Input({ required: true })
  treatmentCalcResponse!: CalcTreatmentResponse;

  @Input()
  reportType: ReportType = ReportType.ECP;

  @Input()
  personalization?: string;

  @Input()
  ethnicity?: GraphDataEthnicity;

  @Output()
  ethnicityChanged = new EventEmitter<GraphDataEthnicity>();

  public ethnicityDict: Record<GraphDataEthnicity, string> = {
    [GraphDataEthnicity.WESTERN]: 'WESTERN_DATA_CHOICE',
    [GraphDataEthnicity.EAST_ASIAN]: 'EAST_ASIAN_DATA_CHOICE',
  };
  public dataSets: Dataset[] = [];
  public selectedDataset?: Dataset;
  public showReferencesDialog = false;

  constructor(private translatePipe: TranslatePipe) {}

  private addDataSets() {
    this.dataSets = this.serCalcResponse!.ethnicities.map(e => {
      const keyForTranslation = this.ethnicityDict[e.graphDataEthnicity];
      return {
        label: keyForTranslation ? this.translatePipe.transform(keyForTranslation) : e.graphDataEthnicity.toString(),
        value: e.graphDataEthnicity,
      };
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshAll();
  }

  ngOnInit(): void {
    if (!this.ethnicity) {
      this.ethnicity = GraphDataEthnicity.WESTERN;
    }
    this.refreshAll();
  }

  private refreshAll() {
    this.addDataSets();
    this.selectedDataset = this.dataSets.find(d => d.value === (this.ethnicity ?? GraphDataEthnicity.WESTERN));
  }

  onDatasetChanged(event: DropdownChangeEvent) {
    this.ethnicity = event.value.value;
    this.selectedDataset = event.value;
    this.refreshAll();
    this.ethnicityChanged.emit(this.ethnicity);
  }

  showReferences() {
    this.showReferencesDialog = true;
  }

  hideReferences() {
    this.showReferencesDialog = false;
  }
}
